import { useSelector } from "react-redux";
import apiAction from "../ajax/service";
import {
  resetPageData,
  setDataByPage,
  setTotalData,
  setRentalInfo,
  setRentAgreements,
  setInvoiceInfo,
  clearRentInfo,
  setTenantsInfo,
} from "../features/rentSlice";
import { loadAdjacentPages } from "./helpers/helpers";
import { current } from "@reduxjs/toolkit";
import { saveActionResultsToState } from "../features/analyticsSlice";

const loadTenants = async (
  dispatch,
  page = 1,
  limit = 25,
  pageData = {},
  tenantsFilters = {}
) => {
  if (pageData instanceof Set) {
    if (pageData.has(page)) return;
  } else {
    if (page in pageData) return;
  }
  
  var data = await apiAction("tenants", { page, limit , filters : tenantsFilters }, "getAll",dispatch);
  dispatch(setTenantsInfo({data:data.data ,page:page, total:data.totalRecords, currentPage:data.currentPage}))
};


const loadTenantAnalytics = async (dispatch) =>{
  var data = await apiAction("stats", { }, "alltenant",dispatch);
  dispatch(saveActionResultsToState({action:"alltenant",result:data}))
}


export { loadTenants , loadTenantAnalytics};
